import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationService } from '../../service/api/organization.service';
import { CopyToClipboardButtonComponent } from '../copy-to-clipboard-button/copy-to-clipboard-button.component';

@Component({
  selector: 'app-conservatore-not-accepted-dialog',
  imports: [CopyToClipboardButtonComponent],
  templateUrl: './conservatore-not-accepted-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConservatoreNotAcceptedDialogComponent {
  private readonly router = inject(Router);
  protected readonly orgService = inject(OrganizationService);

  readonly error = this.orgService.conservatoreNotAcceptedError;

  close(): void {
    this.orgService.dismissConservatoreNotAcceptedError();
  }

  goToConservatori(): void {
    this.orgService.dismissConservatoreNotAcceptedError();
    void this.router.navigate(['/conservatori']);
  }
}
